export default __webpack_public_path__ + "static/media/default_avatar.dd61314f.png";